export const ORDER_ACTION_LABELS: Record<string, string> = {
  Photos: "Upload Photos",
  FamilyTree: "Fill Out Family Tree",
  Missionary: "Fill Out Missionary Form",
  Generational: "Fill Out Generational Form",
  // Add more as needed
};
